
import Api from './Api';
import Configuracao from '../util/Configuracao';

class UsuarioApi extends Api {
  async recuperarUsuarioAplicacao (codUsuario) {
    try {
      const urlUsuarioAplicacao = Configuracao.getConfiguracao().urlUsuarioAplicacao + '/' + codUsuario;
      const response = await this.fetch(urlUsuarioAplicacao);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  // async isUsuarioPrestador (codUsuario) {
  //   try {
  //     const urlIsUsuarioPrestador = Configuracao.getConfiguracao().urlIsUsuarioPrestador + '/' + codUsuario;
  //     const response = await this.fetch(urlIsUsuarioPrestador);
  //     return response.data;
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // async recuperarPrestador (codUsuario) {
  //   try {
  //     const urlRecuperarPrestador = Configuracao.getConfiguracao().urlRecuperarPrestador + '/' + codUsuario;
  //     const response = await this.fetch(urlRecuperarPrestador);
  //     return response.data;
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  async renovarSessao () {
    try {
      const urlMsAutenticacaoTokens = Configuracao.getConfiguracao().urlLogin;
      const response = await this.fetch(urlMsAutenticacaoTokens, 'PUT');

      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default UsuarioApi;
